module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.0.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PP1"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.2.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PP2"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.3.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 1",
      "src": "data/content-0002.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.3.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PA1"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.4.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 2",
      "src": "data/content-0003.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.4.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.3.0.0.box.858.618.412.45.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA2.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.3.0.0.box.858.618.412.45.q.80"
    }
  }, [_vm._v("Also by Frank Davis")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.3.1.0.box.535.726.1066.200.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA2.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "text-align": "center"
    },
    attrs: {
      "id": "para.3.1.0.box.711.726.717.35.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Frank ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Davis ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Seafood ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Notebook ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA2.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "text-align": "center"
    },
    attrs: {
      "id": "para.3.1.1.box.664.782.805.46.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Frank ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Davis ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Cooks ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Naturally ")]), _c('i', [_vm._v(" N'Awlins ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA2.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.3.1.2.box.535.837.1066.45.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Frank ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Davis ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Cooks ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Cajun, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Creole, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Crescent ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("City ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA2.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "text-align": "center"
    },
    attrs: {
      "id": "para.3.1.3.box.732.889.676.37.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.1.0"
    }
  }), _vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.0.0"
    }
  }), _vm._v("Fisherman's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.3.0.0"
    }
  }), _vm._v("Tackle ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.4.0.0"
    }
  }), _vm._v("Box ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.0.0.0"
    }
  }), _vm._v("Bible ")])]), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.2.0.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.2.2.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.1.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.2.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.2.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.3.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.4.0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.6.0"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PA3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.7.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.4.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 4",
      "src": "data/content-0004.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.4.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.4.1.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.4.2.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PA4"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA5"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 5",
      "src": "data/content-0005.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.6.0.0.box.305.626.1331.156.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0",
      "text-align": "center",
      "margin-bottom": "0"
    },
    attrs: {
      "id": "para.6.0.0.box.371.626.1189.47.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("To ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("my ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Benny, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("my ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("littlest ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("grandson ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("my ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("best ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("food ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("critic, ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "text-indent": "0",
      "margin-bottom": "0"
    },
    attrs: {
      "id": "para.6.0.1.box.305.679.1331.48.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("who ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("just ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("so ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("happens ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("like ")]), _vm._v("everything "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("PawPaw ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("has ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ever ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cooked! ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "text-indent": "0",
      "margin-bottom": "0"
    },
    attrs: {
      "id": "para.6.0.2.box.880.737.177.45.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.0.0"
    }
  }), _vm._v("Love ")]), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0"
    }
  }), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.0.0"
    }
  }), _vm._v("y")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.2.0"
    }
  }), _vm._v("a! ")])]), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.8.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.9.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.10.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.11.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.0.0"
    }
  })])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_skipped",
    attrs: {
      "id": "ORIG-GBS.PA7"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0.3"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96af5232","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0006.vue
// module id = 54
// module chunks = 0